import React, {useEffect, useState} from 'react';
import {Typography} from "@mui/material";
import BottomBorder from "../BottomBorder";
import SkeletonLoader from "../SkeletonLoader";
import PackageComponent from "../Package";
import Package from "../../models/Package";
import {useApiService} from "../../context/ApiServiceContext";

// Mention packages only - the plain /package/list deliberately excludes them.
export const AI_MENTIONS_PACKAGES_URL = '/package/list?siteType=mentions';
export const AI_MENTIONS_PACKAGES_ANCHOR = 'ai-packages';

const AiMentionsPackages: React.FC = () => {
    const apiService = useApiService();
    const [packages, setPackages] = useState<Package[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        let cancelled = false;

        apiService.api.get<Package[]>(AI_MENTIONS_PACKAGES_URL)
            .then(response => {
                if (cancelled) {
                    return;
                }
                const data = Array.isArray(response.data) ? response.data : [];
                // Smallest quantity first, like the tier order in the design
                setPackages([...data].sort((a, b) => (a.linksCount ?? 0) - (b.linksCount ?? 0)));
                setIsLoading(false);
            })
            .catch(error => {
                console.error("Fetching mention packages failed", error);
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [apiService]);

    return (
        <section className="lnk-aim__packages" id={AI_MENTIONS_PACKAGES_ANCHOR}>
            <div className="lnk-aim__title-block lnk-aim__title-block--center">
                <Typography variant="h2">חבילות אזכורים</Typography>
                <BottomBorder width={69} addMargin={false}/>
            </div>

            {isLoading ? (
                <div className="lnk-aim__packages-skeletons">
                    <SkeletonLoader amount={3} marginTop={false}/>
                </div>
            ) : packages.length > 0 && (
                // A plain grid, not the homepage carousel: three cards never
                // needed pagination.
                <div className="lnk-aim__wrap lnk-aim__packages-grid">
                    {packages.map(pack => (
                        <div key={pack.id} dir="rtl">
                            <PackageComponent {...pack}/>
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
};

export default AiMentionsPackages;
